import ApiService from '../api.services';

const HistorySgpService = {
  filter: async function (customer, startedAt, finishedAt, services, records, page) {
    try {
      const data = {
        customer, startedAt, finishedAt, services, 
      }
      const response = await ApiService.post(`/api/historysgp?records=${records}&page=${page}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default HistorySgpService;

export { HistorySgpService };

